/*
 *  Author: DL
 *  Date: 2020-12-11 22:03:21
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-21 12:16:47
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

export default {
    isDebug: false,
    isLog: true,
    outdoorGroupID: 1,
    maxCount: 3,
    shortcut: [
        { name: '大法庭', typeID: '1' },
        { name: '民事', typeID: '2' },
        { name: '调解', typeID: '3' },
        { name: '刑事', typeID: '4' },
        { name: '诉讼', typeID: '5' },
        { name: '信访', typeID: '6' },
        { name: '洗手间', typeID: '7' },
        // { name: '电梯', typeID: '8' },
        // { name: '步行梯', typeID: '9' },
    ],
    pickFilter: {
        typeID: [300000, 200506, 200503, 200501],
    },
    gps: false,
    bluetooth: true,
    simulation: false,
    app: false,
    minOffset: 3,
    maxOffset: 6,
};
